
import React, { useEffect, useState } from "react";
import Layout from "../../Common/Components/Layout/Layout";
import { getAppUsage } from "../../Services/chat-bot-service";
import style from "./Usage.module.css";
import { MenuItem, Select } from "@mui/material";
import { menuProps } from "../../Common/Util";
import { Spinner } from "react-bootstrap";
import sortIcon from "../../Assets/svgs/sort.svg";

const Usage = () => {
  const [eventsList, setEventsList] = useState([]);
  const [totalEventsList, setTotalEventsList] = useState([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [dateList, setDateList] = useState<any>([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [sortConfig, setSortConfig] = useState({ field: '', direction: 'ascending' });
  const [totalCount, setTotalCount] = useState({
    date: "", name: 0, totalUsers: 0, totalUserLogins: 0, totalQandA: 0, totalAIInsights: 0
  });
  const processEventsList = (data: any) => {
    setEventsList(data);
    let totalUsers = 0;
    let totalUserLogins = 0;
    let totalQandA = 0;
    let totalAIInsights = 0;
    data.forEach((element: any) => {
      console.log("element:::", element)
      totalUsers += element.users_logged_in;
      totalUserLogins += element.total_user_logins;
      totalQandA += element.total_questions_asked;
      totalAIInsights += element.total_ai_insights_viewed;
    });
    setTotalCount({
      date: selectedDate, name: data.length, totalUsers, totalUserLogins, totalQandA, totalAIInsights
    })
  }
  const getEvents = async (dayCount: number) => {
    setLoading(true);
    const response = await getAppUsage(dayCount);
    if (response && response.length > 0) {
      let dates: string[] = [];
      response.forEach((element: any) => {
        dates.push(element.date);
      });
      const filteredList = dates.filter((value, index, arr) => index === arr.indexOf(value));
      setDateList(filteredList)
      setSelectedDate("");
      setTotalEventsList(response);
      // let filteredEvents: any = [];
      // response.forEach((element: any) => {
      //   if (element.date === filteredList[0]) {
      //     filteredEvents.push(element)
      //   }
      // });
      processEventsList(response)
    }
    setLoading(false);

  }
  const handleDateChange = (e: any) => {
    const currentSelectedDate = e.target.value;
    setSelectedDate(currentSelectedDate);
    let filteredEvents: any = [];
    totalEventsList.forEach((element: any) => {
      if (element.date === currentSelectedDate) {
        filteredEvents.push(element)
      }
    });
    processEventsList(filteredEvents)
  }

  useEffect(() => {
    if (eventsList && eventsList.length === 0) {
      getEvents(30);
    }
  })

  const handleSort = (field: string) => {
    let direction = 'ascending';
    if (sortConfig.field === field && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    const sortedData = [...eventsList].sort((a, b) => {
      if (a[field] < b[field]) return direction === 'ascending' ? -1 : 1;
      if (a[field] > b[field]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });

    processEventsList(sortedData);
    setSortConfig({ field: field, direction });
  };

  return (
    <div className="App">
      <div className={style.usageContainer}>
        <h5>Usage Metrics</h5>
        <div className="justify-content-flex-end mb20">
          <Select
            labelId="select-label"
            id="select"
            value={selectedDate}
            label=""
            onChange={handleDateChange}
            className="f12px"
            style={{ minWidth: '100px' }}
            MenuProps={menuProps(100)}
            placeholder="Date"
          >
            {dateList && dateList.map((option: string, index: number) => {
              return (<MenuItem value={option} key={index} className="f12px" >{option}</MenuItem>)
            })}

          </Select>
        </div>
        {isLoading ? <div className={"loaderWrapper"}>
          <Spinner animation="border" variant="primary">
            <span className="visually-hidden"></span>
          </Spinner>
        </div>
          : <div className={style.tableContainer}><table>
            <tr>
              <th>Date</th>
              <th className={style.tableContainerTh}>Name
                <img src={sortIcon} alt="sortName" className={style.sortImg} onClick={() => handleSort('name')} />
              </th>
              <th className={style.tableContainerTh}>Total User LogIns
                <img src={sortIcon} alt="sortUserLogin" className={style.sortImg} onClick={() => handleSort('users_logged_in')} />
              </th>
              <th className={style.tableContainerTh}>Total AI Insights Viewed
                <img src={sortIcon} alt="sortAiInsights" className={style.sortImg} onClick={() => handleSort('total_ai_insights_viewed')} />
              </th>
              <th className={style.tableContainerTh}>Total Questions Asked
                <img src={sortIcon} alt="sortQuestionAsked" className={style.sortImg} onClick={() => handleSort('total_questions_asked')} />
              </th>
            </tr><tr key={2}>
              <th>GRAND TOTAL</th>
              <th>{totalCount.name}</th>
              <th>{totalCount.totalUserLogins}</th>
              <th>{totalCount.totalAIInsights}</th>
              <th>{totalCount.totalQandA}</th>
            </tr>
            {eventsList && eventsList.length > 0 && eventsList.map((event: any, index: number) => {
              return <tr key={index}>
                <td>{event.date}</td>
                <td>{event.name}</td>
                <td>{event.total_user_logins}</td>
                <td>{event.total_ai_insights_viewed}</td>
                <td>{event.total_questions_asked}</td>
              </tr>
            })}
          </table></div>}

      </div>
    </div >
  );
};

export default Layout(Usage);
